export interface TariffMappingEntity {

    id: number | null,
    priority: number | null,
    tempPriority: number | null,
    chargeType?: string | null,
    chargeOnCompanyCode?: string | null,
    consortiumCode?: string | null,
    physicalHandlingCode?: string | null,
    modalityOfArrival?: string | null,
    modalityOfDeparture?: string | null,
    overWeightInd?: string | null,
    overDimensionInd?: string | null,
    bundleInd?: string | null,
    cntrStatus?: string | null,
    specialHandlingInd?: string | null,
    legSpHandlingInd?: string | null,
    serviceCode?: string | null,
    cntrSize?: string | null,
    cntrType?: string | null,
    directInd?: string | null,
    specialInd?: string | null,
    chargeInd?: string | null,
    tsLegChargeInd?: string | null,
    subChargeType?: string | null,
    loaLimitFrom?: number | null,
    loaLimitTo?: number | null,
    reeferHandlingType?: string | null,
    rcType?: string | null,
    marshallingType?: string | null,
    marshallingFrom?: string | null,
    marshallingTo?: string | null,
    fromTml?: string | null,
    toTml?: string | null,
    serviceOrderCode?: string | null,
    overWeightFrom?: number | null,
    overWeightTo?: number | null,
    shipmentType?: string | null,
    nonCellularVslInd?: string | null,
    wireSlingInd?: string | null,
    palletizedInd?: string | null,
    cargoType?: string | null,
    cargoCode?: string | null,
    shiftCodeOps?: string | null,
    cntrTypeGroup?: string | null,
    specialArea?: string | null,
    roundTripFlag?: string | null,
    opsLine?: string | null,
    forwarderCode?: string | null,
    forwarderRef?: string | null,
    equipmentCodeInd?: string | null,
    emptyIndicator?: string | null,
    partnerCode?: string | null,
    cntrTspStatus?: string | null,
    operationType?: string | null,
    tariffType?: string | null,
    tariffCode?: string | null,
    activeInd: string | null,
    mappingType: string | null,
    liftOnOffInd: string | null,
    serviceRequestCode: string | null,
    subServiceRequestCode: string | null,
    cfsBy: string | null,
    vesselWeightFrom: number | null,
    vesselWeightTo: number | null,
    soa: string | null,
    movementType: string | null,
    marshalLocationType: string | null,

    [key: string]: string | boolean | number | null | Object | undefined
}

export const EMPTY_TARIFF_MAPPING_ENTITY: TariffMappingEntity = {
    id: 0,
    priority: null,
    tempPriority: null,
    chargeType: null,
    chargeOnCompanyCode: null,
    consortiumCode: null,
    physicalHandlingCode: null,
    modalityOfArrival: null,
    modalityOfDeparture: null,
    overWeightInd: null,
    overDimensionInd: null,
    bundleInd: null,
    cntrStatus: null,
    specialHandlingInd: null,
    legSpHandlingInd: null,
    serviceCode: null,
    cntrSize: null,
    cntrType: null,
    directInd: null,
    specialInd: null,
    chargeInd: null,
    tsLegChargeInd: null,
    subChargeType: null,
    loaLimitFrom: null,
    loaLimitTo: null,
    reeferHandlingType: null,
    rcType: null,
    marshallingType: null,
    marshallingFrom: null,
    marshallingTo: null,
    fromTml: null,
    toTml: null,
    serviceOrderCode: null,
    overWeightFrom: null,
    overWeightTo: null,
    shipmentType: null,
    nonCellularVslInd: null,
    wireSlingInd: null,
    palletizedInd: null,
    cargoType: null,
    cargoCode: null,
    shiftCodeOps: null,
    cntrTypeGroup: null,
    specialArea: null,
    roundTripFlag: null,
    opsLine: null,
    forwarderCode: null,
    forwarderRef: null,
    equipmentCodeInd: null,
    emptyIndicator: null,
    partnerCode: null,
    cntrTspStatus: null,
    operationType: null,
    tariffType: null,
    tariffCode: null,
    activeInd: 'Y',
    mappingType: "TariffMappingEntity",
    liftOnOffInd: null,
    serviceRequestCode: null,
    subServiceRequestCode: null,
    cfsBy: null,
    vesselWeightFrom: null,
    vesselWeightTo: null,
    soa: null,
    movementType: null,
    marshalLocationType: null
}
